export default function truthy(value) {
  return Boolean(value);
}
